// Copyright (c) 2022 by Move Closer

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export enum MonthName {
  January = 'january',
  February = 'february',
  March = 'march',
  April = 'april',
  May = 'may',
  June = 'june',
  July = 'july',
  August = 'august',
  September = 'september',
  October = 'october',
  November = 'november',
  December = 'december'
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const monthNamesRegistry: Record<string, string> = {
  0: MonthName.January,
  1: MonthName.February,
  2: MonthName.March,
  3: MonthName.April,
  4: MonthName.May,
  5: MonthName.June,
  6: MonthName.July,
  7: MonthName.August,
  8: MonthName.September,
  9: MonthName.October,
  10: MonthName.November,
  11: MonthName.December
}
